import { MarkdownEditorPage as PlatformMarkdownEditorPage } from '@jarvis/platform-ui';

export function MarkdownEditorPage() {
  return <PlatformMarkdownEditorPage filesLinkTo="/files" filesLinkLabel="Files" />;
}
